<template>
  <v-card class="create-volume">
    <v-card-title> Edit Volume Name </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-text-field
          outlined
          :label="$t('volume.name')"
          v-model="result.name"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save()" depressed large>
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "EditRbuVolumeNameDialog",
  props: {
    volumeId: String,
    volumeName: String,
  },
  setup(props, { root, emit }) {
    const result = ref({
      id: props.volumeId,
      name: props.volumeName,
    });

    const save = async function () {
      if (!result.value.name) {
        root.$store.dispatch(
          ACTION_TYPES.SHOW_SNACKBAR,
          "Volume Name is required"
        );
        return;
      }
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/volume/edit_volume_name/",
        params: {
          volume_id: props.volumeId,
          new_name: result.value.name,
        },
      });

      if (response.body.success) {
        emit("submit", true);
      }
    };

    return {
      result,
      save,
    };
  },
};
</script>
